import React, { Children, type ReactNode } from "react";
import Info from "components/chrome/main_view/info";
import SupportChat from "components/chrome/main_view/support_chat";

interface IErrorProps {
  title?: string;
  contactText?: ReactNode;
  children: ReactNode;
  wrapChildrenWithParagraph?: boolean;
}

export default function Error({
  title,
  contactText,
  children,
  wrapChildrenWithParagraph = true,
}: IErrorProps) {
  const childrenRender = wrapChildrenWithParagraph
    ? Children.map(children, (child, idx) => <p key={idx}>{child}</p>)
    : children;

  return (
    <Info title={title || "Error"}>
      {childrenRender}
      {contactText ?? (
        <p>
          For assistance chat with us at <SupportChat />.
        </p>
      )}
    </Info>
  );
}
